/*!
 * devextreme-angular
 * Version: 24.2.5
 * Build date: Fri Feb 14 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[popup-content-insertion]',
})
export class DxServicePopupInsertionDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
